<app-splash-screen *ngIf="splashscreenVisible | async"></app-splash-screen>
<app-toast></app-toast>
<router-outlet></router-outlet>
<app-tasks-queue></app-tasks-queue>
